module.exports = __webpack_public_path__ + "static/media/hugo_desktop_2.ff1065fa.png";